import { render, staticRenderFns } from "./BotaoSalvar.vue?vue&type=template&id=0d1ed648&scoped=true"
import script from "./BotaoSalvar.vue?vue&type=script&lang=js"
export * from "./BotaoSalvar.vue?vue&type=script&lang=js"
import style0 from "./BotaoSalvar.vue?vue&type=style&index=0&id=0d1ed648&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1ed648",
  null
  
)

export default component.exports